import { Component, EventEmitter, OnInit, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ContactUsService } from '../core/services/contact-us.service';
import { LanguageService } from '../core/services/language.service';
import { ProductCategoryFieldsComponent } from '../core/components/product-category-fields/product-category-fields.component';

@Component({
  selector: 'app-ques-bill-payment',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ProductCategoryFieldsComponent],
  templateUrl: './ques-bill-payment.component.html',
  styleUrl: './ques-bill-payment.component.css'
})
export class QuesBillPaymentComponent implements OnInit, OnDestroy {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  form: FormGroup;
  lang = '';
  private destroy$ = new Subject<void>();

  private readonly EU_REGION_CATEGORIES = [
    'Accidents des personnes',
    'Risques spéciaux',
    'Transport',
    'Entreprises japonaises'
  ];

  constructor(private fb: FormBuilder, private contactUsService: ContactUsService, private languageService: LanguageService) {}

  get labels() { return this.contactUsService.commonLabels; }
  get placeholders() { return this.contactUsService.placeholderTextLabels; }
  get messages() { return this.contactUsService.messageLabels; }

  ngOnInit() {
    this.lang = this.languageService.getLanguageFromUrl();
    const isFR = this.lang === 'fr-fr';

    this.form = this.fb.group({
      region: [isFR ? 'FR' : this.lang === 'en-us' ? 'US' : 'INT'],
      question: ['', [Validators.required, Validators.minLength(20)]],
      ...(isFR ? {
        productCategory: ['', [Validators.required]],
        productCategoryId: [''],
        otherInsurance: [''],
        product: ['', [Validators.required]],
        productId: [''],
        otherProduct: ['']
      } : {})
    });

    if (isFR) {
      this.form.get('productCategory')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
        this.form.get('region')?.setValue(this.EU_REGION_CATEGORIES.includes(value) ? 'EU' : 'FR');
      });
    }

    this.formReady.emit(this.form);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }
}
